// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"111":"admin-texts","190":"docs","258":"reviews","268":"events","594":"about","781":"admin-staff"}[chunkId] || chunkId) + "." + {"64":"0800c8c2","111":"197e3098","153":"9fee913e","190":"277547e5","217":"e3866670","258":"4df84225","268":"cbd93e01","594":"4512bf5b","781":"5e98f0fa"}[chunkId] + ".js";
};